import * as Cookies from 'js-cookie';

const COOKIE_NAME_V3 = 'dashboard.frontend.v3';

export enum Ports {
  ConnectFrontend = 9912,
  Dashboard = 8556,
  API = 8346,
  Portal = 6894,
}

export const getTLD = (location: Location) =>
  location.hostname.split('.')[location.hostname.split('.').length - 1];

export function getTLDWithPort(location: Location, port: Ports) {
  const tld = getTLD(location);
  if (tld === 'website') {
    return `${tld}:${port}`;
  }

  return tld;
}

export const getAPIURL = (location: Location): string => {
  if (typeof import.meta?.env?.REACT_APP_API_URL === 'string') {
    return import.meta.env.REACT_APP_API_URL;
  }
  return `https://api.meter.${getTLDWithPort(location, Ports.API)}`;
};

export const getPortalURL = (location: Location): string => {
  if (typeof import.meta?.env?.REACT_APP_API_URL === 'string') {
    return import.meta.env.REACT_APP_API_URL;
  }
  return `https://portal.meter.${getTLDWithPort(location, Ports.Portal)}`;
};

function safeURL(url: string, path?: string) {
  return `${url}/${path?.startsWith('/') ? path.slice(1) : path}`;
}

export function getProxyURL(location: Location = window.location) {
  const shouldUseAPIWithoutPortal = Cookies.get(COOKIE_NAME_V3);

  return shouldUseAPIWithoutPortal
    ? getAPIURL(window.location)
    : `${getPortalURL(location)}/api-proxy`;
}
export const getProxyURLWith = (path?: string) => safeURL(getProxyURL(), path);

export const getAPIBaseURL = (location: Location) => `${getProxyURL(location)}/v1/connect`;

export function getConnectURL(location: Location, path?: string) {
  const url = `https://connect.meter.${getTLDWithPort(location, Ports.ConnectFrontend)}`;
  return `${url}/${path?.startsWith('/') ? path.slice(1) : path}`;
}
